<template>
  <div class="manageWrapper">
    <div class="search-container">
      <div class="manage-header d-flex align-items-start justify-content-between">
        <div class="w-50 d-flex align-items-center">
          <span class="title">Manage</span>
          <span class="item ml-2">
            <multiselect
              v-model="programClientSelected"
              :options="programClientList"
              :placeholder="programClientList ? programClientSelected.name : 'Empty'"
              label="name"
              class="content"
              :openDirection="'below'"
              :multiple="false"
              :close-on-select="true"
              :hide-selected="true"
              track-by="name"
              :allow-empty="true"
              :show-labels="false"
              @select="selectProgramItemClick">
            </multiselect>
          </span>
        </div>
        <b-button @click="onManageClientSettings">
          Manage Client Settings
        </b-button>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <p class="text-manage-events">Manage your events that are approved and scheduled</p>
        </div>
      </div>

      <div class="container-filter">
        <div class="filter-date-range">
          <div class="text-container">
            <p class="text-date-range">Filter by date range</p>
            <p class="text-clear" @click="clearFilter">Clear Filters</p>
          </div>
          <div class="field-filter d-flex align-items-center">
            <b-form-input type="date" @keydown.enter="onChange" v-model="startDate" locale="en-US"></b-form-input>
            <p>to</p>
            <b-form-input type="date" @keydown.enter="onChange" v-model="endDate" locale="en-US"></b-form-input>
          </div>
        </div>
        <div class="search-events">
          <p>Search</p>
          <b-input-group class="search-events-group">
            <b-form-input
              type="text"
              placeholder="Search by event information"
              v-model="keyword"
              @keydown.enter.native="onSearch"
            ></b-form-input>
            <b-button @click="onChange">
              <Icon name="search" class="search-icon"></Icon>
            </b-button>
          </b-input-group>
        </div>
        <div class="total-count">
          Event Count: {{totalEvents()}}/{{totalCountOfClient}}
        </div>
      </div>
    </div>
    <div class="list-events">
      <div class="list-header">
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Event Date</p>
            <b-button @click="onSort">
              <img src="../../../../static/img/arrow-down.svg" alt="icon"/>
            </b-button>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Event Name</p>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Supply Status</p>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Participant Signups</p>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Event Address</p>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column border-seperate">
            <p class="text-header">Staffing</p>
          </div>
        </div>
        <div class="column event-date">
          <div class="container-column">
            <p class="text-header">Live</p>
          </div>
        </div>
      </div>
      <div class="list-loading d-flex justify-content-center" v-if="loadingList">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div v-if="!loadingList">
        <div class="list-container" v-for="(item, index) in getListSingleEvent" :key="index" >
          <div v-if="item.status === 'APPROVED' || isShowArchivedEvent(item)"
               :class="`list-content ${isShowArchivedEvent(item) ? 'green-line' : ''}`">
            <div class="column event-date">
              <div class="container-column border-seperate">
                <p>{{item.prefDate}}</p>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column border-seperate">
                <p>{{item.eventName}}</p>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column border-seperate">
                <div class="text-icon">
                  <img src="../../../../static/img/ball-green.svg" alt="icon"/>
                  <p>{{item.trackingStatus}}</p>
                </div>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column border-seperate">
                <div class="text-icon">
                  <img src="../../../../static/img/ball-red.svg" alt="icon"/>
                  <p>{{item.numParticipant}}/{{item.maxParticipant}} Participants</p>
                </div>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column border-seperate">
                <p>{{item.fullAddress}}</p>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column border-seperate">
                <div class="text-icon">
                  <img src="../../../../static/img/ball-red.svg" alt="icon"/>
                  <p>{{item.numStaffLead + item.numStaffConcierge + item.numStaffScreener}}/{{item.maxStaffLead + item.maxStaffConcierge + item.maxStaffScreener}} Staff</p>
                </div>
              </div>
            </div>
            <div class="column event-date">
              <div class="container-column">
                <div class="live-click" @click="onMakeLive(item)">
                  <div class="text-icon" v-if="item.isLive">
                    <img src="../../../../static/img/live-blue.svg" alt="icon"/>
                    <p>Live</p>
                  </div>
                  <p class="text-not-live" v-if="!item.isLive">Not Live</p>
                </div>
                <div class="button-view">
                  <b-button class="btn-expand" @click="onEventDetails(item)">
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="load-more">
          <b-spinner v-show="loadMoreLoading" variant="primary" label="Spinning"></b-spinner>
        </div>
        <div>
          <div class="list-group-container" v-for="group in getListEventGroup">
            <div class="container-text d-flex align-items-center">
              <b>{{group.name}}:</b>
              {{group.minDateEventGroup}} - {{group.maxDateEventGroup}}
              <div class="seperate"></div>
              {{group.data.length}}/{{group.totalCount}} events
            </div>
            <div class="list-ca container-ca" v-for="relatedEvent in group.data">
              <div v-if="relatedEvent.status === 'APPROVED' || isShowArchivedEvent(relatedEvent)"
                   :class="`list-group-row ${isShowArchivedEvent(relatedEvent) ? 'green-line' : ''}`">
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <p>{{relatedEvent.prefDate}}</p>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <p>{{relatedEvent.eventName}}</p>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <div class="text-icon">
                      <img src="../../../../static/img/ball-green.svg" alt="icon"/>
                      <p>{{relatedEvent.trackingStatus}}</p>
                    </div>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <div class="text-icon">
                      <img src="../../../../static/img/ball-red.svg" alt="icon"/>
                      <p>{{relatedEvent.numParticipant}}/{{relatedEvent.maxParticipant}} Participants</p>
                    </div>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <p>{{relatedEvent.fullAddress}}</p>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column border-seperate">
                    <div class="text-icon">
                      <img src="../../../../static/img/ball-red.svg" alt="icon"/>
                      <p>{{relatedEvent.numStaffLead + relatedEvent.numStaffConcierge + relatedEvent.numStaffScreener}}/{{relatedEvent.maxStaffLead + relatedEvent.maxStaffConcierge + relatedEvent.maxStaffScreener}} Staff</p>
                    </div>
                  </div>
                </div>
                <div class="column event-date">
                  <div class="container-column">
                    <div class="live-click" @click="onMakeLive(relatedEvent)">
                      <div class="text-icon" v-if="relatedEvent.isLive">
                        <img src="../../../../static/img/live-blue.svg" alt="icon"/>
                        <p>Live</p>
                      </div>
                      <p class="text-not-live" v-if="!relatedEvent.isLive">Not Live</p>
                    </div>
                    <div class="button-view">
                      <b-button class="btn-expand" @click="onEventDetails(relatedEvent)">
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="load-more">
          <b-button v-if="showLoadMoreBtn()" class="btn btn-secondary" @click="onLoadMore">
            Load More
          </b-button>
          <b-spinner v-if="loadMoreLoading" variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Icon from 'vue-awesome/components/Icon';
  import {mapActions, mapGetters} from 'vuex';
  import moment from 'moment';
  import DatePicker from 'vuejs-datepicker';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'manage-approve-event-client-view',
    components: {
      Icon,
      DatePicker,
      Multiselect
    },
    props: {},
    data () {
      return {
        startDate: '',
        endDate: '',
        keyword: '',
        programClientList: [],
        programClientSelected: {
          name: 'All Program',
          startDate: null,
          endDate: null,
          id: null
        },
        events: [],
        eventGroups: [],
        hideLoadMore: true,
        loadMoreLoading: false,
        currentPage: 1,
        itemsPerPage: 10,
        currentItemsPerPage: 10,
        loadingList: false,
        sortReverse: false,
        client: null,
        currentEventDetail: {},
        totalCountOfClient: 0
      }
    },
    methods: {
      onChange () {
        this.getListEvents();
      },
      onSearch (event) {
        if (event.which === 13) {
          this.getListEvents();
        }
      },
      clearFilter () {
        this.startDate = '';
        this.endDate = '';
        this.keyword = '';
        this.getListEvents();
      },
      onLoadMore () {
        let params = {
          noBeginDates: '0',
          noEndDates: 100,
          selectedDate: null,
          clientId: this.$route.params.clientId,
          keyword: this.keyword,
          currentPage: this.currentPage + 1,
          itemsPerPage: this.itemsPerPage,
          sortType: 'dateTime',
          eventStatusRequest: 'ALL',
          eventStatus: ['APPROVED', 'ARCHIVED'],
          requireReport: null,
          startDate: this.formatDate(this.startDate),
          endDate: this.formatDate(this.endDate),
          relatedEventInGroup: true,
          sortReverse: this.sortReverse
        };
        this.loadMoreLoading = true;
        this.getEventsByDates(params).then((res) => {
          this.formatEventAndGroup(res);
          this.currentPage += 1;
          this.currentItemsPerPage = this.currentPage * this.itemsPerPage;
        }).finally(() => {
          this.loadMoreLoading = false;
        });
      },
      onSort () {
        this.sortReverse = !this.sortReverse;
        this.$store.commit('MUTATION_SET_SORT_DATA', {type: this.sortType, reverse: this.sortReverse});
        this.getListEvents();
      },
      onManageClientSettings () {
        if (!this.client) return;
        this.$modal.show('customMessageModal', this.client.id);
      },
      getListEvents () {
        let params = {
          noBeginDates: '0',
          noEndDates: 100,
          selectedDate: null,
          clientId: this.$route.params.clientId,
          keyword: this.keyword,
          currentPage: 1,
          itemsPerPage: this.isHasNoFilter() ? this.currentItemsPerPage : null,
          sortType: 'dateTime',
          eventStatusRequest: 'ALL',
          eventStatus: ['APPROVED', 'ARCHIVED'],
          requireReport: null,
          startDate: this.formatDate(this.startDate),
          endDate: this.formatDate(this.endDate),
          relatedEventInGroup: true,
          sortReverse: this.sortReverse
        };
        this.loadingList = true;
        this.events = [];
        this.eventGroups = [];
        return new Promise((resolve) => {
          this.getEventsByDates(params).then((res) => {
            this.formatEventAndGroup(res);
            resolve(res);
          }).finally(() => {
            this.loadingList = false;
            this.loadMoreLoading = false;
          });
        })
      },
      formatEventAndGroup (response) {
        const eventRaw = response.approvedEvents != null ? response.approvedEvents[0].events : [];
        this.events = [];
        this.eventGroups = [];
        eventRaw.forEach(event => {
          if (event.countRelatedEvents && event.countRelatedEvents > 0) {
            this.eventGroups.push({
              id: event.eventGroupId,
              name: event.eventGroupName || event.eventName,
              minDateEventGroup: event.minDateEventGroup,
              maxDateEventGroup: event.maxDateEventGroup,
              totalCount: event.countRelatedEvents + 1, // relatedEvent + mainEvent
              data: [event].concat(event.relatedEvents),
              sortType: this.sortType,
              sortReverse: this.sortReverse
            });
          } else {
            this.events.push(event);
          }
        });
        this.hideLoadMore = response.totalEvents ? this.totalEvents() === response.totalEvents : true;
        this.$store.commit('MUTATION_SET_LIST_EVENT_GROUP', this.eventGroups);
        this.$store.commit('MUTATION_SET_LIST_SINGLE_EVENT', this.events);
      },
      totalEvents () {
        let eventInGroupCount = 0;
        this.eventGroups.forEach(group => { eventInGroupCount += group.data.length; });
        return this.events.length + eventInGroupCount;
      },
      showLoadMoreBtn () {
        return !this.hideLoadMore && !this.loadMoreLoading && this.isHasNoFilter();
      },
      isHasNoFilter () {
        return this.startDate === '' && this.endDate === '' && this.keyword === '';
      },
      getClientInfo () {
        this.getClient(this.$route.params.clientId).then(response => {
          this.client = response.data.data;
        });
      },
      formatDate (value) {
        if (!value) return '';
        return moment(value).format('MM/DD/YYYY');
      },
      selectProgramItemClick (item) {
        if (item !== this.programClientSelected) {
          this.programClientSelected = item;

          if (this.programClientSelected.startDate) {
            this.startDate = moment(this.programClientSelected.startDate).format('YYYY-MM-DD');
          } else {
            this.startDate = null;
          }

          if (this.programClientSelected.endDate) {
            this.endDate = moment(this.programClientSelected.endDate).format('YYYY-MM-DD');
          } else {
            this.endDate = null;
          }
          this.getListEvents();
        }
      },
      onEventDetails (event) {
        this.currentEventDetail = event;
        this.$modal.show('eventDetailModal', { eventId: this.currentEventDetail.id, onChangeEventLive: this.onChangeEventLive, onChangeEvent: this.onChangeEvent });
      },
      onMakeLive (event) {
        this.actionUpdateIsLiveEvent({
          eventId: event.id,
          isCheck: !event.isLive,
          onlineType: 'LIVE'
        }).then((response) => {
          if (response.message) {
            this.$toastr('error', response.message, '');
          } else {
            event.isLive = response.event.isLive;
            this.$toastr('success', 'Update event successful!', '');
          }
        });
      },
      onChangeEventLive (isLive) {
        this.currentEventDetail.isLive = isLive;
      },
      onChangeEvent (event) {
        this.currentEventDetail.isLive = event.isLive;
        this.currentEventDetail.eventName = event.eventName;
        this.currentEventDetail.prefDate = event.prefDate;
        this.currentEventDetail.trackingStatus = event.trackingStatus;
        this.currentEventDetail.fullAddress = event.fullAddress;
        this.currentEventDetail.maxStaffLead = event.maxStaffLead;
        this.currentEventDetail.maxStaffConcierge = event.maxStaffConcierge;
        this.currentEventDetail.maxStaffScreener = event.maxStaffScreener;
      },
      isShowArchivedEvent (event) {
        return event.status === 'ARCHIVED';
      },
      ...mapActions({
        getEventsByDates: 'ACTION_GET_EVENTS_DATES',
        getClient: 'ACTION_GET_CLIENT',
        actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
        getProgramClientAction: 'ACTION_GET_PROGRAM_CLIENT'
      })
    },
    computed: {
      ...mapGetters({
        getListEventGroup: 'GETTER_LIST_EVENT_GROUP',
        getListSingleEvent: 'GETTER_LIST_SINGLE_EVENT'
      })
    },
    created () {
      this.clientId = this.$route.params.clientId;
      this.getClientInfo();
      this.getListEvents().then((res) => {
        this.totalCountOfClient = res.totalEvents || 0;

        this.getProgramClientAction(this.clientId).then((response) => {
          if (response.programPs.length > 0) {
            this.programClientSelected = null;
            this.programClientList = response.programPs;
            this.programClientList.unshift({
              name: 'All Program',
              startDate: null,
              endDate: null,
              id: null
            });
            for (let i = 0; i < response.programPs.length; i++) {
              if (response.programPs[i].status === 'Active') {
                this.programClientSelected = response.programPs[i];
                break;
              }
            }
            if (!this.programClientSelected) {
              this.programClientSelected = response.programPs[1];
            }
            this.startDate = moment(this.programClientSelected.startDate).format('YYYY-MM-DD');
            this.endDate = moment(this.programClientSelected.endDate).format('YYYY-MM-DD');
            this.getListEvents();
          }
        });
      });
    },
    watch: {}
  };
</script>



// WEBPACK FOOTER //
// Manage.vue?35b16dd6